<div class="container-fluid py-4">
  <div class="pb-4">
    <div class="pt-4 pb-2 heading-container">
      <h1 class="d-inline-block align-middle m-0" data-test-id="preferences-page-heading">
        {{ 'PREFERENCES_TITLE' | translate }}
      </h1>
    </div>
  </div>

  <!-- Tab Navigation -->
  <ng-container *ngIf="hasDoctorRole$ | async">
    <ul class="nav nav-tabs mb-4">
      <li class="nav-item">
        <a
          class="nav-link"
          data-test-id="preferences-tab-notifications"
          [routerLink]="['notifications']"
          routerLinkActive="active"
          role="tab"
        >
          {{ 'NOTIFICATION_PREFERENCES_TAB_TITLE' | translate }}
        </a>
      </li>
      <li class="nav-item">
        <a
          class="nav-link"
          data-test-id="preferences-tab-distribution"
          [routerLink]="['distribution']"
          routerLinkActive="active"
          role="tab"
        >
          {{ 'DISTRIBUTION_SETTINGS_TAB_TITLE' | translate }}
        </a>
      </li>
    </ul>
  </ng-container>

  <!-- Tab Content -->
  <div class="tab-content">
    <div class="tab-pane active">
      <router-outlet></router-outlet>
    </div>
  </div>
</div>
